// CHG-130 REQ-DHR-021/022: 프로젝트 일반 회의록 진입점
import api from '../lib/axios';
import type { ApiResponse } from '@maios/shared';

export interface GeneralMeetingListItem {
  id: string;
  title: string;
  scrumDate: string | null;
  // CHG-130: 'GENERAL_MEETING' | 'TEMPLATE' | 'BLANK' | null — 출처 구분용 (배지 등)
  sourceType: string | null;
  createdAt: string;
  creator: { id: string; name: string; avatarUrl: string | null };
}

export interface GeneralMeetingsResponse {
  spaceId: string;
  folderId: string;
  documents: GeneralMeetingListItem[];
}

export async function fetchGeneralMeetings(projectId: string, limit = 20): Promise<GeneralMeetingsResponse> {
  const res = await api.get<ApiResponse<GeneralMeetingsResponse>>(
    `/projects/${projectId}/documents/general-meetings?limit=${limit}`,
  );
  return res.data.data!;
}

// 일반 회의록 생성 — 기존 /team-spaces/:spaceId/documents 본 호출
export interface CreateGeneralMeetingInput {
  spaceId: string;
  parentDocumentId: string; // GENERAL_MEETING 폴더 ID
  title: string;
  scrumDate: string;        // 'YYYY-MM-DD'
  content?: unknown;        // 빈 Tiptap doc 등
}

// CHG-130 REQ-DHR-028: 프로젝트 문서함 메타 (spaceId + 자동 폴더 3개)
export interface ProjectDocumentSpace {
  spaceId: string;
  autoFolders: {
    rootId: string;
    dailyScrumId: string;
    generalMeetingId: string;
  };
}

export async function fetchProjectDocumentSpace(projectId: string): Promise<ProjectDocumentSpace> {
  const res = await api.get<ApiResponse<ProjectDocumentSpace>>(
    `/projects/${projectId}/document-space`,
  );
  return res.data.data!;
}

export async function createGeneralMeeting(input: CreateGeneralMeetingInput) {
  const res = await api.post<ApiResponse<{ id: string; title: string }>>(
    `/team-spaces/${input.spaceId}/documents`,
    {
      title: input.title,
      parentDocumentId: input.parentDocumentId,
      sourceType: 'GENERAL_MEETING',
      scrumDate: input.scrumDate,
      content: input.content,
    },
  );
  return res.data.data!;
}
